function t(r) {
  return typeof r == "object" && "length" in r ? r : Array.from(r);
}
export {
  t as default
};
